var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value.default_value.length < 1 && !_vm.value.unique_id
    ? _c("empty", { attrs: { value: _vm.value } })
    : _c("div", { staticClass: "saas_module_plate_inner" }, [
        _c(
          "div",
          {
            class: [
              "saas_module_plate",
              _vm.value.config.style == "2" && "border",
            ],
            style: _vm.Styles,
          },
          [
            _c("div", { staticClass: "header" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("el-image", {
                    staticClass: "icon",
                    attrs: { src: _vm.value.config.title_bar_image },
                  }),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.value.config.title)),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "more" }, [
                _vm.value.config.style == "2"
                  ? _c("div", [_vm._v("查看更多")])
                  : _vm._e(),
                _c("i", { staticClass: "el-icon el-icon-arrow-right" }),
              ]),
            ]),
            _vm.value.config.style == "2"
              ? _c(
                  "div",
                  { staticClass: "content2" },
                  _vm._l(_vm.value.default_value, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "box activity_title_common" },
                      [
                        _vm.value.config.prefix_icon
                          ? _c("div", {
                              staticClass: "icon",
                              style: {
                                backgroundImage:
                                  "url(" + _vm.value.config.prefix_icon + ")",
                              },
                            })
                          : _vm._e(),
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "content" }, [
                  _vm.module_type === "activity"
                    ? _c(
                        "div",
                        { staticClass: "activity" },
                        _vm._l(_vm.value.default_value, function (item) {
                          return _c(
                            "div",
                            { key: item.id, staticClass: "activity-item" },
                            [
                              item.thumb
                                ? _c("img", {
                                    staticClass: "img",
                                    attrs: { src: item.thumb },
                                  })
                                : _vm._e(),
                              _c("div", { staticClass: "text-wrap" }, [
                                _c(
                                  "div",
                                  { staticClass: "activity_title_common" },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "status",
                                    style: {
                                      background:
                                        item.status == 0
                                          ? "rgba(226, 225, 225, 1)"
                                          : item.status == 1
                                          ? "#57c0ff"
                                          : "rgba(254, 214, 171, 1)",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.status_cn))]
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  ["vote", "ask", "examine"].includes(_vm.module_type)
                    ? _c("div", { staticClass: "vote" }, [
                        _c(
                          "div",
                          { staticClass: "info" },
                          _vm._l(_vm.value.default_value, function (i, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "info-item" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "item activity_title_common" },
                                  [_vm._v(" " + _vm._s(i.title) + " ")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "list__con-tips",
                                    class:
                                      i.status == 0
                                        ? "noTime"
                                        : i.status == 1
                                        ? "NewTime"
                                        : "hadTime",
                                  },
                                  [_vm._v(_vm._s(i.status_cn))]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm.module_type === "workforum"
                    ? _c("div", { staticClass: "workers" }, [
                        _c(
                          "div",
                          { staticClass: "title activity_title_common" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.value.default_value[0].title) +
                                " "
                            ),
                          ]
                        ),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.value.default_value[0].count) + "人参与"
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.module_type == "forum"
                    ? _c("div", { staticClass: "forum-manage" }, [
                        _c(
                          "div",
                          { staticClass: "forum-info" },
                          _vm._l(
                            _vm.value.default_value,
                            function (items, idx) {
                              return _c(
                                "div",
                                {
                                  key: idx,
                                  staticClass:
                                    "forum-name activity_title_common",
                                },
                                [_vm._v(" " + _vm._s(items.title) + " ")]
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                  ["content", "signinclock"].includes(_vm.module_type)
                    ? _c(
                        "div",
                        { staticClass: "news" },
                        _vm._l(_vm.value.default_value, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "news-info" },
                            [
                              _c("div", { staticClass: "left" }, [
                                item.thumb
                                  ? _c("img", {
                                      staticClass: "img",
                                      attrs: { src: item.thumb },
                                    })
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "right" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "article-title activity_title_common",
                                  },
                                  [_vm._v(" " + _vm._s(item.title) + " ")]
                                ),
                                _c("div", { staticClass: "article-text" }, [
                                  _vm._v(_vm._s(item.content)),
                                ]),
                                _c("div", { staticClass: "time" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.hd_start_time) +
                                      " " +
                                      _vm._s(
                                        _vm.module_type === "signinclock"
                                          ? " ~ " + item.hd_end_time
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  ["briskwalking", "step", "lottery"].includes(_vm.module_type)
                    ? _c(
                        "div",
                        { staticClass: "news" },
                        _vm._l(_vm.value.default_value, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "news-info" },
                            [
                              _c("div", { staticClass: "left" }, [
                                item.thumb
                                  ? _c("img", {
                                      staticClass: "img",
                                      attrs: { src: item.thumb },
                                    })
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "right" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "article-title activity_title_common",
                                  },
                                  [_vm._v(" " + _vm._s(item.title) + " ")]
                                ),
                                _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "time" }, [
                                    _vm._v(_vm._s(item.hd_start_time)),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "time",
                                      staticStyle: { "margin-top": "5px" },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.hd_end_time) + " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "article-text" }),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }